import { captureException } from '@sentry/react';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      captureException(error, {
        extra: {
          queryKey: query.queryKey,
          meta: query.meta,
        },
      });

      console.error('[Query error]', query.queryKey, error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      captureException(error, {
        extra: {
          mutationKey: mutation.options.mutationKey,
          meta: mutation.meta,
        },
      });

      console.error('[Mutation error]', mutation.options.mutationKey, error);
    },
  }),
});
